const debounce = require("lodash.debounce");

class Accordion {
  // Dom elements
  accordion;
  header;
  body;
  maxHeight;
  button;
  content;

  // Classes
  headerClass = "accordion__header";
  bodyClass = "accordion__body";
  animateClass = "accordion--animate";
  expandClass = "accordion--expand";
  buttonClass = "accordion__button";
  contentClass = "accordion__content";
  responsiveClass = "accordion--responsive";

  constructor(elem) {
    this.accordion = elem;

    if (this.accordion) {
      this.header = this.accordion.querySelector(`.${this.headerClass}`);
      this.body = this.accordion.querySelector(`.${this.bodyClass}`);
      this.button = this.accordion.querySelector(`.${this.buttonClass}`);
      this.content = this.accordion.querySelector(`.${this.contentClass}`);

      // Set initial max height (and subsequently, the animate class)
      if (this.body) this.setMaxHeight();

      // display none by default
      if (!this.isStatic() && this.content) this.content.style.display = "none";

      // Add event listeners
      this.header.addEventListener("click", this.toggleAccordion.bind(this));
      window.addEventListener(
        "resize",
        debounce(this.setMaxHeight.bind(this)),
        100,
        { maxWait: 600 }
      );

      if (this.accordion.classList.contains(this.responsiveClass)) {
        window.addEventListener("resize", this.setResponsiveStatic);
        window.addEventListener("load", this.setResponsiveStatic);
      }
    }
  }

  setResponsiveStatic = () => {
    // make footer static accoridion for desktop
    if (
      window.squiz.breakpoints.md.matches ||
      window.squiz.breakpoints.lg.matches ||
      window.squiz.breakpoints.xl.matches
    ) {
      this.accordion.classList.add("accordion-static");
    } else {
      this.accordion.classList.remove("accordion-static");
    }
  };

  isStatic = () => {
    return this.accordion.classList.contains("accordion-static");
  };

  setMaxHeight = () => {
    // Remove the animation class so we can calculate the height quickly
    this.accordion.classList.remove(this.animateClass);

    // Remove any max height already set
    const currentMaxHeight = this.body.style.maxHeight;
    this.body.style.maxHeight = null;

    // Add the expand class momentarily so we can calculate the height of the accordion body
    const isExpanded = this.accordion.classList.contains(this.expandClass);
    if (!isExpanded) {
      this.accordion.classList.add(this.expandClass);
    }

    // Record maxHeight
    // this.maxHeight = `${this.body.offsetHeight}px`;
    this.maxHeight = `9999px`;

    // Remove the expand class if this wasn't originally open
    if (!isExpanded) {
      this.accordion.classList.remove(this.expandClass);
      this.body.style.display = null;
    }
    // // Return max height
    this.body.style.maxHeight = this.maxHeight;

    this.toggleAnimation(true);
  };

  toggleAnimation = (toggle) => {
    // Return the animate class after a brief delay to avoid glitchy transition animations
    if (toggle)
      setTimeout(() => {
        this.accordion.classList.add(this.animateClass);
      }, 10);
    else {
      this.accordion.classList.remove(this.animateClass);
    }
  };

  toggleAccordion = () => {
    // no toggling for static accordion
    if (this.isStatic()) return;

    const isExpanded = this.accordion.classList.contains(this.expandClass);

    // Toggle expanded
    this.accordion.classList.toggle(this.expandClass);

    // set aria
    if (this.button) this.button.setAttribute("aria-expanded", !isExpanded);

    // Set maxHeight for expansion
    if (!isExpanded) {
      this.content.style.display = "block";
      // this.body.style.maxHeight = this.maxHeight;
      this.body.style.maxHeight = '9999px';
    } else {
      setTimeout(() => {
        this.content.style.display = "none";
      }, 250);
      this.body.style.maxHeight = 0;
    }
  };
}

// init accordions
const accordionItems = document.querySelectorAll(".accordion");
accordionItems.forEach((accordion) => {
  new Accordion(accordion);
});

